module.exports = __webpack_public_path__ + "img/avion.5771a934.png";